import { useCallback, useRef, useState } from "react";

export function usePendingAction() {
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false);

  const run = useCallback(async <T>(action: () => Promise<T>) => {
    if (pendingRef.current) return undefined;

    pendingRef.current = true;
    setPending(true);
    try {
      return await action();
    } finally {
      pendingRef.current = false;
      setPending(false);
    }
  }, []);

  return { pending, run };
}
